import { NgModule } from '@angular/core';
import { cartBaseTranslationChunksConfig, cartBaseTranslationsDe, cartBaseTranslationsEn } from '@spartacus/cart/base/assets';
import { ADD_TO_CART_FEATURE, CART_BASE_FEATURE, CartBaseRootModule, MINI_CART_FEATURE } from '@spartacus/cart/base/root';
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core';
import { nl as translationsNl } from '../../../../assets/i18n-assets/nl';

@NgModule({
  declarations: [],
  imports: [
    CartBaseRootModule
  ],
  providers: [provideConfig(<CmsConfig>{
    featureModules: {
      [CART_BASE_FEATURE]: {
        module: () =>
            import('@spartacus/cart/base').then((m) => m.CartBaseModule),
      },
    }
  }),
    provideConfig(<CmsConfig>{
      featureModules: {
        [MINI_CART_FEATURE]: {
          module: () =>
              import('../../../components/uig-cart/uig-mini-cart/uig-mini-cart.module').then((m) => m.UigMiniCartModule),
        },
      }
    }),
    provideConfig(<CmsConfig>{
      featureModules: {
        [ADD_TO_CART_FEATURE]: {
          module: () =>
              import('../../../components/uig-cart/uig-add-to-cart/uig-add-to-cart.module').then((m) => m.UigAddToCartModule),
        },
      }
    }),
    provideConfig({
    i18n: {
      resources: {
          en: cartBaseTranslationsEn,
          de: cartBaseTranslationsDe,
          nl: translationsNl,
        },
      chunks: cartBaseTranslationChunksConfig,
    },
  } as I18nConfig)]
})
export class CartBaseFeatureModule { }
